import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { X, Save, ChevronLeft, ChevronRight } from "react-feather";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { Button, Modal, ModalBody } from "reactstrap";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLaptopFile } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/AuthContext";
import { LabSelect } from "../../components/course/select";
import { humanDateFormatShort } from "../../../config/constants";
import Tabs from "./Tabs";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import useFetcher from "../../hooks/useFetcher";
import useMutter from "../../hooks/useMutter";
import { fetchNotaDePedidoById, getNotasDePedidoCategory, patchNotaDePedido } from "../../services/notasDePedidoServices";
import { getDerivaciones, patchDerivacion, postDerivacion } from "../../services/derivacionServices";
import CloseNPModal from "./closeNP/closeNPModal";
import ReasonForCosureModal from "./closeNP/reasonForClosureModal";
import CandidatosNP from "../../components/CandidatosNP";
import ReasonForCancelModal from "./closeNP/reasonForCancelModal";
import { getColorByEstado, getTextByEstado, addTransparency } from "../NotasDePedido/utils";
import BackupFileModal from "./closeNP/backupFileModal";
import { InputText } from "../../ui/inputs";
import { FechaBox, FechaBoxText, InfoText, InfoTextValues, InfoTextValuesBold, TabsContainer, TabsToogle } from "./styles";
import { ButtonPrimary, IconButton } from "../../ui/buttons";
import AvisoDeEmpleoForm from "./avisoDeEmpleo";
import modulos from "../../mocks/modulos";
import OrdenesDeVentaModal from "./ordenesDeVenta";
import { getKPICandidatos } from "../../services/candidatosNPServices";

const arrowStyle = { cursor: "pointer", zIndex: "1", width: "30px", color: "#F0292A", alignSelf: "flex-start", marginTop: "400px" };
const retriveNotaObj = (itemId, pagination) => {
  let nota;
  let isLoading;
  let setNota;

  // eslint-disable-next-line prefer-const
  [nota, isLoading, , setNota] = useFetcher(fetchNotaDePedidoById, [itemId, pagination]);

  if (nota.rows) {
    [nota] = nota.rows;
  }

  const actualizarNota = (nuevaNota) => {
    setNota(nuevaNota);
  };

  return [nota, isLoading, actualizarNota];
};

const getAreaById = (id, areas) => {
  const area = areas.find((objeto) => objeto.id === id);
  return area ? area.nombre : "-";
};

const hasNDaysPassed = (date, days) => {
  if (!date || typeof days !== "number") return false;

  const givenDate = new Date(date);
  const today = new Date();

  const differenceInDays = (today - givenDate) / (1000 * 60 * 60 * 24);

  return differenceInDays >= days;
};

const NotasDePedidoDetail = ({ match, location, history }) => {
  const { currentUser } = useAuth();
  const isAudit = currentUser.haveAuditAccess(modulos.NOTAS_DE_PEDIDO);
  const [pagination] = useState(match.params.pagination || location.search);
  const itemId = JSON.parse(match.params.id);
  const [modifyingStatus, setModifyingStatus] = useState(false);
  const [nota, isLoading, setNota] = retriveNotaObj(itemId, pagination);
  const [notasDePedidoCat, isLoadingNotasDePedidoCat] = useFetcher(getNotasDePedidoCategory, undefined, "getNotasDePedidoCategory");
  const [candidatosKPI, isLoadingCandidatosKPI, , , fetchCandidatosKPI] = useFetcher(getKPICandidatos, [nota.id]);
  const [saveNotaCall, isSavingNota] = useMutter(patchNotaDePedido);
  const [editNotaForm, setEditNotaForm] = useState(false);
  const status = nota ? nota.estado : "sin estado";
  const estadosCat = notasDePedidoCat.estadoNP ? notasDePedidoCat.estadoNP : "";
  const motivosCat = notasDePedidoCat.motivoNP ? notasDePedidoCat.motivoNP.type : "";
  const areasCat = notasDePedidoCat.areas ? notasDePedidoCat.areas : "";
  const activityComponent = useRef();
  const [derivacionId, setDerivacionId] = useState(null);
  const [derivaciones, , , setDerivaciones, fetchDerivaciones] = useFetcher(getDerivaciones, [itemId]);
  const [derivacionesData, setDerivacionesData] = useState([]);
  const [editDerivacionForm, setEditDerivacionForm] = useState(false);
  const [wasDerived, setWasDerived] = useState(false);
  const [coberturaState, setCoberturaState] = useState(null);
  const fechaActual = moment().format("YYYY-MM-DD");
  const [closeNP, setCloseNP] = useState(false);
  const [estadoClose, setEstadoClose] = useState("");
  const [anularCancelar, setAnularCancelar] = useState(false);
  const [cerrarSinCubrir, setCerrarSinCubrir] = useState(false);
  const [cancelarMotivo, setCancelarMotivo] = useState(false);
  const [showBackupFileModal, setShowBackupFileModal] = useState(false);
  const [reloadCandidatos, setReloadCandidatos] = useState(false);
  const [reloadDerivaciones, setReloadDerivaciones] = useState(false);
  const [modifyingCargo, setModifyingCargo] = useState(false);
  const [cargoValue, setCargoValue] = useState(nota.cargo);
  const [canCancel, setCanCancel] = useState(false);
  const [reloadFiles, setReloadFiles] = useState(false);
  const [motivoToCancel, setMotivoToCancel] = useState("");

  const [showOrdenesDeVenta, setShowOrdenesDeVenta] = useState(false);
  const canCreateOV = nota && nota.servicio && nota.servicio === 1 && nota.origen && nota.origen === 2 && nota.estado !== 10 && nota.estado !== 12;

  // navegacion entre notas
  const [anterior, setAnterior] = useState(null);
  const [siguiente, setSiguiente] = useState(null);

  // Tabs open and close
  const [showTabs, setShowTabs] = useState(true);
  const [closing, setClosing] = useState(false);
  const [showAvisoForm, setShowAvisoForm] = useState(false);
  const [haveCandidatos, setHaveCandidatos] = useState(false);
  const [triggerCheckIngresos, setTriggerCheckIngresos] = useState(false);
  const [showIngresosMessage, setShowIngresosMessage] = useState(false);

  const ingresos = derivacionesData
    ? derivacionesData
        .map((derivacion) => {
          return derivacion.cubiertas;
        })
        .reduce((a, b) => a + b, 0)
    : null;

  useEffect(() => {
    if (reloadCandidatos) {
      fetchCandidatosKPI();
    }
  }, [reloadCandidatos]);

  useEffect(() => {
    if (derivaciones) {
      setDerivacionesData(derivaciones.rows);
    }
    setReloadDerivaciones(false);
  }, [derivaciones, reloadDerivaciones]);

  const handleToggle = () => {
    if (showTabs) {
      setClosing(true);
      setTimeout(() => {
        setShowTabs(false);
        setClosing(false);
      }, 200);
    } else {
      setShowTabs(true);
    }
  };

  useEffect(() => {
    if (nota && nota.navegacion) {
      if (nota && nota.navegacion && nota.navegacion.anterior) {
        setAnterior(nota.navegacion.anterior);
      } else {
        setAnterior(null);
      }
      if (nota && nota.navegacion && nota.navegacion.siguiente) {
        setSiguiente(nota.navegacion.siguiente);
      } else {
        setSiguiente(null);
      }
    }
  }, [nota, itemId]);

  // Determina si el usuario puede cancelar la nota de pedido en base a su posicion y su region
  useEffect(() => {
    const posicion = currentUser && currentUser.user && currentUser.user.Pi && currentUser.user.Pi.posicion;
    const regiones = currentUser && currentUser.user && currentUser.user.sucursalesAsignadas && currentUser.user.sucursalesAsignadas.map((suc) => suc.region2);
    const regionNP = nota && nota.region;
    const hasRegion = regiones && regiones.includes(regionNP);
    setCanCancel(hasRegion && posicion === 6);
  }, [currentUser, nota]);

  useEffect(() => {
    if (reloadDerivaciones) fetchDerivaciones();
    setReloadDerivaciones(false);
  }, [reloadDerivaciones]);

  // orden de opciones Abierta; Reclutando; Derivando;
  // Parcialmente Cubierta; Pre Ingreso; Cubierta; Anulada; Pre Cancelada; Cancelada
  const estadosOptions = estadosCat.type
    ? estadosCat.type
        .map((e) => {
          return { label: e.text, value: e.id, id: e.id };
        })
        .sort((a, b) => {
          const order = [1, 2, 3, 11, 4, 8, 5, 6, 9, 7, 10];
          return order.indexOf(a.id) - order.indexOf(b.id);
        })
        // no se muestra la opción Preventiva
        .filter((e) => e.value !== 10)
        // no se muestra la opcion Base Preventiva
        .filter((e) => e.value !== 12)
    : [];

  let estadosOptionsFiltered = nota.estado === 1 ? estadosOptions : estadosOptions.filter((e) => e.value !== 2);
  // si el usuario no puede cancelar la nota de pedido, se elimina la opción de Cancelada
  estadosOptionsFiltered = canCancel ? estadosOptionsFiltered : estadosOptionsFiltered.filter((e) => e.value !== 7);

  // si la nota esta en "Base Preventiva" ó "Preventiva",
  // se muestran solo las opciones de "Anulada", "Pre Cancelada", "Cancelada"
  estadosOptionsFiltered =
    nota.estado === 12 || nota.estado === 10 ? estadosOptionsFiltered.filter((e) => e.value === 6 || e.value === 7 || e.value === 9) : estadosOptionsFiltered;

  // se muestran solo las opciones de "Anulada", "Pre Cancelada", "Cancelada"
  estadosOptionsFiltered =
    nota.estado === 4 && ingresos && ingresos > 0
      ? estadosOptionsFiltered.filter((e) => e.value === 5 || e.value === 6 || e.value === 7 || e.value === 9)
      : estadosOptionsFiltered;

  // No se muestra en el select la opcion "Parcialmente Cubierta" ni "Derivada"
  estadosOptionsFiltered = estadosOptionsFiltered.filter((e) => e.value !== 4 && e.value !== 3);
  const [currentState, setCurrentState] = useState(status);

  useEffect(() => {
    setCurrentState(status);
    if (status === 6 || status === 7 || nota.estado === 5) {
      setAnularCancelar(true);
    } else {
      setAnularCancelar(false);
    }
    // el auditor solo puede ver la info de la nota de pedido
    if (isAudit) setAnularCancelar(true);
  }, [status, isAudit]);

  const handleNotaSave = async (editData) => {
    const [result] = await saveNotaCall([itemId, editData]);
    if (result) {
      setModifyingStatus(false);
      setNota(result);
      activityComponent.current.refreshActivities();
    }
  };

  const handleCloseNpWithOfferedService = async (newStatus) => {
    if (!newStatus) return;
    await handleNotaSave({ estado: newStatus, fechaCerrada: fechaActual });
  };

  const handleEditData = async (editData) => {
    await handleNotaSave({
      cargo: editData.cargo,
      recruiter: editData.recruiter,
      sourcer: editData.sourcer,
      posicion: editData.posicion,
      vacantes: editData.vacantes,
      contactoNombre: editData.nombre,
      contactoEmail: editData.email,
      contactoTelefono: editData.telefono,
    });
  };

  useEffect(() => {
    if (nota && nota.fechaPrimeraDerivacion) {
      setWasDerived(true);
    } else {
      setWasDerived(false);
    }
  }, [nota, itemId]);

  const handleNotaStateAutomatic = async () => {
    // evita errores con notas que arrastran el error de vacantes = 0
    if (nota.vacantes === 0) return;
    const { estado, fechaAbierta } = nota;
    let apertura;

    if (estado === 10) {
      apertura = fechaActual;
    } else {
      apertura = fechaAbierta;
    }

    // Verifica si hay alguna derivación en los últimos 30 segundos
    const thirtySecondsAgo = moment().subtract(30, "seconds");
    const derivacionMasReciente =
      nota && nota.derivacionNP
        ? nota.derivacionNP.reduce((minDerivacion, derivacion) => {
            return moment(derivacion.createdAt).isBefore(minDerivacion.createdAt) ? derivacion : minDerivacion;
          }, nota.derivacionNP[0])
        : null;
    const isDerivacionRecent = derivacionMasReciente && moment(derivacionMasReciente.createdAt).isAfter(thirtySecondsAgo);

    if (nota.vacantes > coberturaState && coberturaState > 0 && wasDerived && status !== 4) {
      await handleNotaSave({ estado: 4, fechaAbierta: apertura });
    }
    if (coberturaState === nota.vacantes && wasDerived && status !== 5) {
      await handleNotaSave({ estado: 5, fechaCerrada: fechaActual, fechaAbierta: apertura });
    }
    // solo cambia automaticamente cuando la nota fue derivada por primera vez
    if (coberturaState === 0 && wasDerived && status !== 3 && isDerivacionRecent) {
      await handleNotaSave({ estado: 3, fechaAbierta: apertura });
    }
  };

  useEffect(() => {
    // si el estado es  Pre Cancelada, Cancelada, Anulada o Entrvista Cliente, no se hace nada
    if ((nota && nota.estado === 9) || (nota && nota.estado === 7) || (nota && nota.estado === 6) || (nota && nota.estado === 11)) {
      return;
    }

    // espera a recargar la nota para setear el estado
    if (!isLoading && !isLoadingNotasDePedidoCat) {
      handleNotaStateAutomatic();
    }
  }, [coberturaState, itemId, nota, wasDerived, status, isLoading]);

  //-----------------------------------------------------------------
  const handleCreateDerivacion = async (derivacionData) => {
    const { message, result } = await postDerivacion(derivacionData);
    toast.success(message);

    // estado 3: Derivada
    const newStatus = wasDerived ? nota.estado : 3;

    // se agrega fecha de ingreso manualmente pisando la fecha anterior
    if (derivacionData.fechaDeIngreso) {
      await handleNotaSave({ estado: newStatus, fechaDeIngreso: derivacionData.fechaDeIngreso });
    }

    // se agrega fecha de reclutando manualmente
    if (!nota.fechaDeReclutando) {
      await handleNotaSave({ estado: newStatus, fechaDeReclutando: derivacionData.fechaDerivacion });
    }

    // si la nota estaba en estado preventiva, le agrega la fecha de abertura
    if (nota.estado === 10 || nota.estado === 12) {
      await handleNotaSave({ estado: newStatus, fechaAbierta: derivacionData.fechaDerivacion });
    } else {
      await handleNotaSave({ estado: newStatus });
    }

    setDerivaciones({ rows: [...derivaciones.rows, result] });
    activityComponent.current.refreshActivities();
    setReloadCandidatos(true);
  };
  //-----------------------------------------------------------------

  const handleEditDerivacion = async (editData) => {
    let newData = {};
    if (!editData.candidatosDetalle) {
      newData = {
        ...editData,
        candidatosDetalle: [],
      };
    } else {
      newData = {
        ...editData,
      };
    }

    // se agrega fecha de ingreso manualmente pisando la fecha anterior
    if (editData.fechaDeIngreso) {
      await handleNotaSave({ fechaDeIngreso: editData.fechaDeIngreso });
    }

    const { message, result } = await patchDerivacion(newData.notaDePedidoId, newData);
    toast.success(message);
    setDerivaciones({ rows: derivaciones.rows.map((row) => (row.id === result.id ? result : row)) });
    activityComponent.current.refreshActivities();

    setEditDerivacionForm(false);
    setReloadCandidatos(true);
    setReloadDerivaciones(true);
  };

  const deleteCandidatoDerivado = (editData) => {
    const { candidatos } = derivacionesData.find((item) => item.id === editData.derivacionId);
    handleEditDerivacion({ notaDePedidoId: editData.derivacionId, candidatos: candidatos - 1 });
  };

  const handleIngresoCandidato = () => {
    fetchDerivaciones();
    setTimeout(() => {
      setTriggerCheckIngresos(true);
    }, 1000);
  };

  useEffect(() => {
    if (!triggerCheckIngresos) return;

    if (ingresos > 0 && ingresos < nota.vacantes) {
      setShowIngresosMessage(true);
    } else {
      setShowIngresosMessage(false);
    }
    setTriggerCheckIngresos(false);
  }, [ingresos, triggerCheckIngresos, nota]);

  const handleAnularCancelar = async (estado) => {
    if (estado === 6) {
      setReloadFiles(true);
      setAnularCancelar(true);
      await handleNotaSave({ estado: 6, fechaCerrada: fechaActual });
    } else if (estado === 9) {
      setCancelarMotivo(true);
    }
  };

  const handleCerrarSinCubrir = async (motivo) => {
    await handleNotaSave({ estado: 5, fechaCerrada: fechaActual, motivo });
  };

  const handleCancelarMotivo = async () => {
    // se agrega una variable global para el motivo de cancelar
    // para poder cambiar el orden de los modales. Primero elige motivo, despues archivo de respaldo
    if (motivoToCancel) {
      setReloadFiles(true);
      await handleNotaSave({ estado: 9, motivo: motivoToCancel });
    }
    setMotivoToCancel("");
  };
  const handleStatusChange = async (selected) => {
    const { estado, fechaAbierta } = nota;
    const newState = selected.value;
    let apertura;

    if (newState === 11 && derivaciones && derivaciones.count === 0) {
      toast.error("Para cambiar el estado a Entrevista Cliente debe haber al menos una derivación creada");
      return;
    }

    if ((newState === 6 || newState === 7 || newState === 9) && ingresos > 0) {
      toast.error("Tienes candidatos en estado INGRESO, por lo que no puedes cancelar ni anular la vacante. Parar cerrar el proceso debes utilizar la opción cubierta.");
      return;
    }

    if (newState === 8 && !haveCandidatos) {
      toast.error("Para cambiar el estado a Pre-Ingreso debe haber al menos un candidato");
      return;
    }

    if (estado === 10) {
      apertura = fechaActual;
    } else {
      apertura = fechaAbierta;
    }
    setCurrentState(newState);

    if (newState === 6 || newState === 9) {
      setEstadoClose(newState);
      setCloseNP(true);
    } else if (newState === 5) {
      if (nota.vacantes > coberturaState) {
        setCerrarSinCubrir(true);
      } else if (nota.vacantes === coberturaState || coberturaState > nota.vacantes) {
        handleNotaSave({ estado: newState, fechaCerrada: fechaActual });
      }
    } else if (newState === 2 && nota.fechaDeReclutando === null) {
      handleNotaSave({ estado: newState, fechaCerrada: null, fechaDeReclutando: fechaActual, fechaAbierta: apertura });
    } else if ([1, 2, 3, 4].includes(newState)) {
      handleNotaSave({ estado: newState, fechaCerrada: null, fechaAbierta: apertura });
    } else if (newState === 7) {
      handleNotaSave({ estado: newState, fechaCerrada: fechaActual, fechaAbierta: apertura });
    } else if (newState === 11) {
      handleNotaSave({ estado: newState, fechaEntrevista: fechaActual });
    } else {
      handleNotaSave({ estado: newState, fechaAbierta: apertura });
    }
  };

  const handleCargoChange = () => {
    handleNotaSave({ cargo: cargoValue });
  };

  const statusColor = getColorByEstado(nota.estado);
  const parcialmenteCubierta = nota.estado === 4 ? { fontSize: "14px" } : {};
  const statusBackground = addTransparency(statusColor, 0.2);

  const handleClickedLeft = () => {
    if (anterior) {
      history.push({
        pathname: `/notasDePedido/${anterior}/detail/${pagination}`,
      });
    }
    return true;
  };

  const handleClickedRight = () => {
    if (siguiente) {
      history.push({
        pathname: `/notasDePedido/${siguiente}/detail/${pagination}`,
      });
    }
    return true;
  };

  const handleBackButton = () => {
    if (pagination) {
      history.push({
        pathname: `/notasDePedido`,
        search: pagination,
      });
    } else {
      history.push({
        pathname: `/notasDePedido`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>PIN - Nota de Pedido {JSON.stringify(itemId)}</title>
      </Helmet>
      {canCreateOV && (
        <ButtonPrimary
          onClick={() => setShowOrdenesDeVenta(!showOrdenesDeVenta)}
          style={
            (nota.estado === 5 && hasNDaysPassed(nota.fechaCerrada, 14)) || nota.estado === 6 || nota.estado === 7 || nota.estado === 9
              ? { display: "flex", alignItems: "center", position: "absolute", right: "150px", zIndex: "1", marginTop: "30px", opacity: "0.5" }
              : { display: "flex", alignItems: "center", position: "absolute", right: "150px", zIndex: "1", marginTop: "30px" }
          }
        >
          Facturación
          <FontAwesomeIcon icon="fa-solid fa-file-invoice-dollar" style={{ marginLeft: "5px" }} />
        </ButtonPrimary>
      )}
      {showOrdenesDeVenta && (
        <OrdenesDeVentaModal
          toggle={() => setShowOrdenesDeVenta(!showOrdenesDeVenta)}
          isOpen={showOrdenesDeVenta}
          nota={nota}
          handleCloseNpWithOfferedService={handleCloseNpWithOfferedService}
        />
      )}
      <ButtonPrimary
        onClick={() => setShowAvisoForm(!showAvisoForm)}
        style={{ display: "flex", alignItems: "center", position: "absolute", right: "30px", zIndex: "1", marginTop: "30px" }}
        disabled={anularCancelar}
      >
        Aviso
        <FontAwesomeIcon icon={faLaptopFile} style={{ marginLeft: "5px" }} />
      </ButtonPrimary>
      {showAvisoForm && <AvisoDeEmpleoForm toggle={() => setShowAvisoForm(!showAvisoForm)} isOpen={showAvisoForm} nota={nota} setNota={setNota} />}
      <Breadcrumb
        title={nota.razonSocial}
        parent={`Nota de Pedido ${itemId}`}
        currentLevel={nota.origen && estadosCat && [1, 2, 3].includes(nota.origen) ? estadosCat.origen.find((o) => o.id === nota.origen).text || "none" : "none"}
        backButton
        onBackButton={handleBackButton}
      />
      <BlurSpinner isLoading={isLoadingNotasDePedidoCat || isSavingNota || isLoading}>
        <div className="d-flex">
          {anterior && <ChevronLeft size="20" onClick={handleClickedLeft} style={arrowStyle} />}
          <div className="container-fluid px-1">
            <div className="row">
              <div className="col-lg-12 pb-3">
                <div className="row">
                  <div className="col-lg-12">
                    {/* Status card */}
                    <div className="card mb-2">
                      <div className="col-lg-12 d-flex justify-content-between">
                        {/* ESTADO DE LA NP------------------------------- */}
                        <div className="col-lg-3 px-0 d-flex align-items-center justify-content-start">
                          <div className="body w-100">
                            {/* CLOSE MODALS  --------------------------------------------------- */}
                            {closeNP && (
                              <CloseNPModal
                                toggle={() => {
                                  setCloseNP(!closeNP);
                                  setReloadFiles(false);
                                }}
                                isOpen={closeNP}
                                estado={estadoClose}
                                setShowBackupFileModal={setShowBackupFileModal}
                                handleAnularCancelar={handleAnularCancelar}
                              />
                            )}
                            {cerrarSinCubrir && (
                              <ReasonForCosureModal
                                toggle={() => {
                                  setCerrarSinCubrir(!cerrarSinCubrir);
                                  setReloadFiles(false);
                                }}
                                isOpen={cerrarSinCubrir}
                                handleCerrarSinCubrir={handleCerrarSinCubrir}
                                motivos={motivosCat}
                              />
                            )}
                            {cancelarMotivo && (
                              <ReasonForCancelModal
                                toggle={() => {
                                  setCancelarMotivo(!cancelarMotivo);
                                  setReloadFiles(false);
                                }}
                                isOpen={cancelarMotivo}
                                setShowBackupFileModal={setShowBackupFileModal}
                                setMotivoToCancel={setMotivoToCancel}
                                motivos={motivosCat}
                              />
                            )}

                            {showBackupFileModal && (
                              <BackupFileModal
                                toggle={() => setShowBackupFileModal(!showBackupFileModal)}
                                id={itemId}
                                isOpen={showBackupFileModal}
                                estado={estadoClose}
                                handleAnularCancelar={handleAnularCancelar}
                                handleCancelarMotivo={handleCancelarMotivo}
                              />
                            )}
                            {/* --------------------------------------------------- */}
                            {modifyingStatus ? (
                              <>
                                <div className="d-flex w-100 align-items-center mt-3">
                                  <LabSelect
                                    name="status"
                                    className="w-100 ml-2"
                                    options={estadosOptionsFiltered}
                                    onChange={handleStatusChange}
                                    value={estadosOptions.find((option) => {
                                      return option.value === currentState;
                                    })}
                                  />
                                  <Button className="px-0 py-auto" color="link" onClick={() => setModifyingStatus(!modifyingStatus)}>
                                    <X size="18" color="#293134" />
                                  </Button>
                                </div>
                              </>
                            ) : (
                              <>
                                <button
                                  className="mt-2 second-step"
                                  type="button"
                                  style={{
                                    border: "none",
                                    background: "none",
                                    outline: "none",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setModifyingStatus(!modifyingStatus)}
                                  disabled={anularCancelar}
                                >
                                  <h4 style={{ fontFamily: "Nunito" }}>
                                    <div
                                      className="px-2 py-1 d-flex align-items-center justify-content-center"
                                      style={{
                                        fontSize: "unset",
                                        background: `${statusBackground}`,
                                        borderRadius: "4px",
                                        minHeight: "35px",
                                        minWidth: "100px",
                                      }}
                                    >
                                      <p
                                        className="m-0 p-0"
                                        style={(parcialmenteCubierta, { fontFamily: "Nunito", fontWeight: "bold", fontSize: "16px", color: `${statusColor}` })}
                                      >
                                        {nota && nota.estado ? getTextByEstado(nota.estado, estadosCat && estadosCat.type) : "-"}
                                      </p>
                                    </div>
                                    {nota.motivo ? <p>{nota.motivo}</p> : null}
                                  </h4>
                                </button>
                              </>
                            )}
                          </div>
                        </div>

                        {/* INFO KPIs-------------------------- */}
                        <div className="col-lg-9 d-flex align-items-center justify-content-end" style={{ height: "fit-content" }}>
                          <div
                            className="d-flex justify-content-end pt-3 third-step"
                            style={{ fontFamily: "Nunito", fontWeight: "bold", fontSize: "14px", height: "fit-content" }}
                          >
                            <InfoText className="my-0 mx-2">
                              <InfoTextValuesBold>Area:</InfoTextValuesBold>
                              <InfoTextValues>{nota && areasCat ? getAreaById(nota.codigoDeAreaId, areasCat) : "-"}</InfoTextValues>
                            </InfoText>
                            <InfoText className="my-0 mx-2">
                              <InfoTextValuesBold>Posicion:</InfoTextValuesBold>
                              <InfoTextValues>{nota ? nota.posicion : "-"}</InfoTextValues>
                            </InfoText>
                            <InfoText className="my-0 mx-2">
                              <InfoTextValuesBold>Cargo:</InfoTextValuesBold>
                              {modifyingCargo ? (
                                <>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div className="p-0">
                                      <InputText
                                        style={{ borderBottom: "1px solid #ccc", height: "20px", padding: "0 5px" }}
                                        className="w-100"
                                        type="text"
                                        name="cargo"
                                        value={cargoValue}
                                        onChange={(e) => setCargoValue(e.target.value)}
                                      />
                                    </div>
                                    <div className="d-flex">
                                      <Button
                                        className="px-1"
                                        size="xs"
                                        color="link"
                                        onClick={() => {
                                          handleCargoChange();
                                          setModifyingCargo(!modifyingCargo);
                                        }}
                                      >
                                        <Save size="14" color="#293134" />
                                      </Button>
                                      <Button className="px-1" size="xs" color="link" onClick={() => setModifyingCargo(!modifyingCargo)}>
                                        <X size="14" color="#293134" />
                                      </Button>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>
                                    <button
                                      type="button"
                                      style={{ border: "none", background: "none", cursor: "pointer", color: "#313131" }}
                                      id="btnModifyingAsignado"
                                      color="link"
                                      onClick={() => setModifyingCargo(!modifyingCargo)}
                                      disabled={anularCancelar}
                                      className="font-weight-bold mt-0 pt-0"
                                    >
                                      <InfoTextValues>{nota ? nota.cargo : "-"}</InfoTextValues>
                                    </button>
                                  </div>
                                </>
                              )}
                            </InfoText>
                          </div>
                        </div>
                      </div>

                      {/* FECHAS--------------------- */}
                      <div className="p-1 d-flex justify-content-around fourth-step" style={{ fontFamily: "Nunito" }}>
                        {nota.fechaAbierta ? (
                          <FechaBox>
                            <FechaBoxText className="mr-1">Apertura</FechaBoxText>
                            <FechaBoxText colorText="#F0292A">{nota.fechaAbierta ? moment.utc(nota.fechaAbierta).format(humanDateFormatShort) : "-"}</FechaBoxText>
                          </FechaBox>
                        ) : (
                          <FechaBox>
                            <FechaBoxText className="mr-1">{nota.origen === 2 ? "Preventiva" : "Base Preventiva"}</FechaBoxText>
                            <FechaBoxText colorText="#F0292A">{nota.fechaPreventiva ? moment.utc(nota.fechaPreventiva).format(humanDateFormatShort) : "-"}</FechaBoxText>
                          </FechaBox>
                        )}

                        <FechaBox>
                          <FechaBoxText className="mr-1">Reclutando</FechaBoxText>
                          <FechaBoxText colorText="#F0292A">
                            {nota.fechaDeReclutando ? moment.utc(nota.fechaDeReclutando).format(humanDateFormatShort) : "-"}
                          </FechaBoxText>
                        </FechaBox>

                        <FechaBox>
                          <FechaBoxText className="mr-1">Derivación</FechaBoxText>
                          <FechaBoxText colorText="#F0292A">
                            {nota.fechaPrimeraDerivacion ? moment.utc(nota.fechaPrimeraDerivacion).format(humanDateFormatShort) : "-"}
                          </FechaBoxText>
                        </FechaBox>

                        <FechaBox>
                          <FechaBoxText className="mr-1">Entrevista</FechaBoxText>
                          <FechaBoxText colorText="#F0292A">{nota.fechaEntrevista ? moment.utc(nota.fechaEntrevista).format(humanDateFormatShort) : "-"}</FechaBoxText>
                        </FechaBox>

                        <FechaBox>
                          <FechaBoxText className="mr-1">Ingreso</FechaBoxText>
                          <FechaBoxText colorText="#F0292A">{nota.fechaDeIngreso ? moment.utc(nota.fechaDeIngreso).format(humanDateFormatShort) : "-"}</FechaBoxText>
                        </FechaBox>

                        <FechaBox>
                          <FechaBoxText className="mr-1">Cierre</FechaBoxText>
                          <FechaBoxText colorText="#F0292A">{nota.fechaCerrada ? moment.utc(nota.fechaCerrada).format(humanDateFormatShort) : "-"}</FechaBoxText>
                        </FechaBox>
                      </div>
                    </div>
                  </div>
                  {/* ------------- */}

                  <BlurSpinner isLoading={isLoadingCandidatosKPI}>
                    <div className="col-lg-12" style={{ fontFamily: "Nunito" }}>
                      <h5 className="mt-3 mb-1" style={{ fontWeight: 800, fontSize: "18px" }}>
                        Candidatos:
                      </h5>
                      <div className="p-1 card w-100 flex-row justify-content-around mb-2">
                        <FechaBox width="18%">
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="w-100 p-2">
                            <p className="mb-0" style={{ fontSize: "14px" }}>
                              Vacantes:{" "}
                            </p>
                            <h4 className="mb-0 pl-1" style={{ fontWeight: 700, fontSize: "16px" }}>
                              {nota ? nota.vacantes : "-"}
                            </h4>
                          </div>
                        </FechaBox>
                        <FechaBox width="18%">
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="w-100 p-2">
                            <p className="mb-0" style={{ fontSize: "14px" }}>
                              Postulados:{" "}
                            </p>
                            <h4 className="mb-0 pl-1" style={{ fontWeight: 700, fontSize: "16px" }}>
                              {candidatosKPI && candidatosKPI.fechaPostuladoCount ? candidatosKPI.fechaPostuladoCount : "-"}
                            </h4>
                          </div>
                        </FechaBox>
                        <FechaBox width="18%">
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="w-100 p-2">
                            <p className="mb-0" style={{ fontSize: "14px" }}>
                              Reclutando:{" "}
                            </p>
                            <h4 className="mb-0 pl-1" style={{ fontWeight: 700, fontSize: "16px" }}>
                              {candidatosKPI && candidatosKPI.fechaReclutandoCount ? candidatosKPI.fechaReclutandoCount : "-"}
                            </h4>
                          </div>
                        </FechaBox>
                        <FechaBox width="18%">
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="w-100 p-2">
                            <p className="mb-0" style={{ fontSize: "14px" }}>
                              Derivados:
                            </p>
                            <h4 className="mb-0 pl-1" style={{ fontWeight: 700, fontSize: "16px" }}>
                              {candidatosKPI && candidatosKPI.fechaDerivadoCount ? candidatosKPI.fechaDerivadoCount : "-"}
                            </h4>
                          </div>
                        </FechaBox>
                        <FechaBox width="18%">
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="w-100 p-2">
                            <p className="mb-0" style={{ fontSize: "14px" }}>
                              Ingresos:{" "}
                            </p>
                            <h4 className="mb-0 pl-1" style={{ fontWeight: 700, fontSize: "16px" }}>
                              {ingresos || "-"}
                            </h4>
                          </div>
                        </FechaBox>
                      </div>
                    </div>
                  </BlurSpinner>

                  {/* ----------------------------- */}
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <CandidatosNP
                      nota={nota}
                      derivacionesData={derivacionesData}
                      notaDePedidoId={itemId}
                      derivacionId={derivacionId}
                      setDerivacionId={setDerivacionId}
                      handleEditDerivacion={handleEditDerivacion}
                      coberturaState={coberturaState}
                      vacantes={nota.vacantes}
                      estadoNP={nota.estado}
                      anularCancelar={anularCancelar}
                      handleIngresoCandidato={handleIngresoCandidato}
                      handleNotaSave={handleNotaSave}
                      reloadCandidatos={reloadCandidatos}
                      setReloadCandidatos={setReloadCandidatos}
                      setReloadDerivaciones={setReloadDerivaciones}
                      deleteCandidatoDerivado={deleteCandidatoDerivado}
                      handleCreateDerivacion={handleCreateDerivacion}
                      editDerivacionForm={editDerivacionForm}
                      setEditDerivacionForm={setEditDerivacionForm}
                      setCoberturaState={setCoberturaState}
                      canCreateOV={canCreateOV}
                      setHaveCandidatos={setHaveCandidatos}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {siguiente && <ChevronRight size="20" onClick={handleClickedRight} style={arrowStyle} />}
          <TabsContainer className={closing ? "slide-out" : "slide-in"} style={showTabs ? { minWidth: "25%" } : { minWidth: "0px" }}>
            <TabsToogle type="button" onClick={handleToggle} aria-label="Close">
              {showTabs ? <ChevronRight size="20" color="#F0292A" /> : <ChevronLeft size="20" color="#F0292A" />}
            </TabsToogle>
            {showTabs && (
              <div className={closing ? "col-lg-12 pr-0 pb-3 tab-content slide-out" : "col-lg-12 pr-0 pb-3 tab-content slide-in"}>
                <div className="card mb-2 full-height">
                  <div className="card-body p-2">
                    <Tabs
                      activityComponent={activityComponent}
                      id={itemId}
                      entity="notaDePedido"
                      disabled={anularCancelar}
                      nota={nota}
                      editNotaForm={editNotaForm}
                      setEditNotaForm={setEditNotaForm}
                      handleEditData={handleEditData}
                      reloadFiles={reloadFiles}
                      categories={notasDePedidoCat}
                    />
                  </div>
                </div>
              </div>
            )}
          </TabsContainer>
        </div>
      </BlurSpinner>

      {/* mensaje para ingresos parcialmente cubiertos */}
      <Modal isOpen={showIngresosMessage} centered style={{ fontFamily: "Nunito" }}>
        <ModalBody>
          <div>
            <div className="d-flex justify-content-end align-items-center mb-3">
              <IconButton onClick={() => setShowIngresosMessage(!showIngresosMessage)}>
                <X />
              </IconButton>
            </div>
            <p className="mx-3 text-center" style={{ fontSize: "16px" }}>
              Si ya ingresaste todos los candidatos que correspondian a este pedido, cambiá el status a CUBIERTA e indicá el motivo por el cual no cubriste la solicitud
              inicial.
            </p>
            <div className="d-flex justify-content-end align-items-center mb-3">
              <ButtonPrimary onClick={() => setShowIngresosMessage(!showIngresosMessage)}>Continuar</ButtonPrimary>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default withRouter(NotasDePedidoDetail);
